const colors = {
  red: '#F24405',
  blue: '#0583F2',
  green: '#C4D926',
}

export default colors
